/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Deployservicev3Destination } from '../models/Deployservicev3Destination';
import { HttpFile } from '../http/http';

/**
* Impression allocation for one destination in a distributed order line.
*/
export class V1DestinationAllocation {
    'destination'?: Deployservicev3Destination;
    /**
    * Allocated impressions for this destination.
    */
    'allocatedImpressions'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "destination",
            "baseName": "destination",
            "type": "Deployservicev3Destination",
            "format": ""
        },
        {
            "name": "allocatedImpressions",
            "baseName": "allocated_impressions",
            "type": "number",
            "format": "int32"
        }    ];

    static getAttributeTypeMap() {
        return V1DestinationAllocation.attributeTypeMap;
    }

    public constructor() {
    }
}

